import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[appPorcentagem]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PorcentagemDirective),
            multi: true,
        }
    ]
})
export class PorcentagemDirective {
    private onChange!: (value: number) => void;
    private onTouced!: () => void;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef
    ) { }

    @HostListener('input', ['$event'])
    onInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D/g, '');        

        if (value.length === 0) {
            this.renderer.setProperty(this.el.nativeElement, 'value', '');
            if (this.onChange) this.onChange(0);
            return;
        }

        let numericValue = parseFloat(value) / 100000;

        const formattedValue = numericValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 5,
            maximumFractionDigits: 5
        });

        // const formattedValue = numericValue;

        this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);

        if (this.onChange) this.onChange(numericValue);
    }

    @HostListener('blur')
    onBlur() {
        if (this.onTouced) this.onTouced;
    }

    writeValue(value: number): void {
        if (value !== null && value !== undefined) {
            const formattedValue = value.toLocaleString('pt-BR', {
                minimumFractionDigits: 5,
                maximumFractionDigits: 5
            });

            this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
        } else {
            this.renderer.setProperty(this.el.nativeElement, 'value', '');
        }
    }

    registerOnChange(fn: (value: number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouced = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.renderer.setProperty(this.el.nativeElement, 'disebled', isDisabled);
    }
}
